// frontend/src/pages/admin/interventions/legacyRedirects.js
//
// The two former standalone admin pages now live inside the admin dashboard's
// Interventions tab. Their old URLs stay reachable - bookmarks, and admin
// emails / push notifications already delivered - by redirecting (history
// REPLACE, so Back does not bounce through the dead URL):
//
//   /admin/interventions     -> /admin?tab=14
//   /admin/quota-management  -> /admin?tab=14&sub=quotas
//
// The same redirect also serves two URLs that were never pages at all but
// were linked from admin emails (they rendered a blank screen):
//
//   /admin/review-queue      -> /admin?tab=2   (profession review queue)
//   /admin/professions       -> /admin?tab=2
//
// Neither old page read any query param, but any the URL carries (utm tags,
// say) are forwarded untouched. `tab` and `sub` are the two the target owns,
// so they are always overwritten, never forwarded.

import React from "react";
import { Navigate, useLocation } from "react-router-dom";

export const INTERVENTIONS_TAB_INDEX = 14;
export const PROFESSIONS_TAB_INDEX = 2;

export function buildLegacyAdminTarget(search, sub, tab = INTERVENTIONS_TAB_INDEX) {
  const incoming = new URLSearchParams(search || "");
  const next = new URLSearchParams();
  next.set("tab", String(tab));
  if (sub) next.set("sub", sub);
  incoming.forEach((value, key) => {
    if (key !== "tab" && key !== "sub") next.append(key, value);
  });
  return `/admin?${next.toString()}`;
}

export function LegacyAdminRedirect({ sub, tab }) {
  const location = useLocation();
  return <Navigate to={buildLegacyAdminTarget(location.search, sub, tab)} replace />;
}
